import { Http } from '@angular/http';

export class Week {
  week: number;
  weekCode: string;
  lastUpdate?: string;
  data? = [];
  loaded?: boolean = false;
  http: Http;

  constructor(week, weekCode, http) {
    console.log("week constructor", week);
    this.week = week;
    this.weekCode = weekCode;
    this.http = http;
    this.lastUpdate = new Date().toLocaleString("es-CL");
  }

  load?() {
    return new Promise((resolve, reject) => {
      /* const url = '/assets/data/week.json'
        return this.http.get(url).subscribe((resp)=>{
          const d = resp.json();
          if(d.ok){
            console.log("week",this.weekCode,"loaded!");
            this.loaded = true;
            this.data = d.data;
            resolve(true);
          }else{
            reject(d);
          }
        },(e)=>{
          reject(e)
        });
      }) */


      const url = 'https://irp-system.web.app/weekMenuFitfood';
      this.http.post(url, {
        'company': 'NeozyuxJrPPNiwkwiPfy',
        'week': this.weekCode,
        'flagSys': true
      }).subscribe((resp) => {
        const d = resp.json();
        if (d.ok) {
          console.log("week", this.weekCode, "loaded!");
          this.loaded = true;
          this.data = d.data;
          resolve(true);
        } else {
          reject(d);
        }
      }, (e) => {
        reject(e)
      });
    });
  }
}



export class WeekMaker {
  static create(event: Week) {
    return new Week(event.week, event.weekCode, event.http);
  }
}




// WEBPACK FOOTER //
// ./src/models/week.model.ts